'use client';

/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { createContext } from 'react';

// Types
import { PageFileContextValue } from './types';
/* -------------------------------------------------------------------------- */
/*                                   Context                                  */
/* -------------------------------------------------------------------------- */

const PageFileContext = createContext<PageFileContextValue>({
  viewRedactedFile: false,
  toggleViewRedactedFile: () => {},
  fileInsightsOpened: false,
  toggleFileInsightsOpened: () => {},
  selectedText: '',
  onSelectText: () => {},
  translatedText: '',
  onTranslationReady: () => {},
  onResetTranslation: () => {},
});

const PageFileProvider = PageFileContext.Provider;

export { PageFileContext, PageFileProvider };
